// material-ui
import { Grid } from '@material-ui/core';
import React from 'react';

// api
import { ResourceActiveEnabled } from '~/src/dash/api/console-api';
import { ICountryGroup } from '~/src/dash/api/console-api';
import { getCountryGroupsByPublisherID } from '~/src/dash/api/country-group';
import {
  getInventoryRoutesByPublisherID,
  IDestination,
  IInventoryRoute,
  RoutingConditionTargetingParams,
} from '~/src/dash/api/inventory_routes';
// other
import { IStore } from '~/src/dash/reducers/store';
import {
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
} from '~/src/dash/types/props';
// utils
import { decorate } from '~/src/dash/utils/decorator';
import { IPermissionCheck, IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { LoadingView } from '~/src/dash/views/loading-view';
// views
import { RouteSettingsView } from '~/src/dash/views/route/route-settings-view';

interface IProps extends IReduxActionProps, ISessionStateProps, IUserStateProps, IHistoryProps {}

interface IState {
  publisherCountryGroups: ICountryGroup[];
  loaded: boolean;
  inventoryRoutesForPublisher: IInventoryRoute[];
}

export const RouteSettingsNewView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      publisherCountryGroups: [] as ICountryGroup[],
      loaded: false,
      inventoryRoutesForPublisher: [] as IInventoryRoute[],
    };

    componentDidMount() {
      this.getCountryGroupsByPublisherIDWrapper();
      getInventoryRoutesByPublisherID(this.props.session.publisher.ID).then((inventoryRoutes) =>
        this.setState({ inventoryRoutesForPublisher: inventoryRoutes }),
      );
    }

    getCountryGroupsByPublisherIDWrapper = () => {
      const { session } = this.props;
      getCountryGroupsByPublisherID(session.publisher.ID).then((countryGroups: ICountryGroup[]) => {
        this.setState({
          publisherCountryGroups: countryGroups,
          loaded: true,
        });
      });
    };

    hasWriteRights = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_inventory_route'], this.props.user.user);
    };

    render() {
      const { publisherCountryGroups, loaded, inventoryRoutesForPublisher } = this.state;

      if (loaded) {
        return (
          <Grid>
            <RouteSettingsView
              // NOTE: New fields added to an route will have to be added here
              // IDs are set to 0 which allows new IDs to be created by API
              currentRoute={
                {
                  ID: 0,
                  EndpointURL: '',
                  Name: 'New Inventory Route',
                  Active: ResourceActiveEnabled,
                  RoutingCondition: RoutingConditionTargetingParams,
                  PublisherID: parseInt(this.props.session.publisher.ID, 10),
                  Destinations: [] as IDestination[],
                  PublisherUUID: this.props.session.publisher.UUID,
                  Region: 'USA',
                  EndpointURLParams: '',
                  FreewheelPublisherID: null,
                  Timeout: 2000,
                } as IInventoryRoute
              }
              publisherCountryGroups={publisherCountryGroups}
              readOnly={!this.hasWriteRights().isAuthorized}
              disableAppBar={false}
              inventoryRoutesForPublisher={inventoryRoutesForPublisher}
            />
          </Grid>
        );
      } else {
        return <LoadingView active={true} text='Loading the route settings' />;
      }
    }
  },
);
